import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { HashLink } from 'react-router-hash-link';

import ROUTES from 'config/routes';
import history from 'services/history';
import ModalModule from 'modules/modal';
import Icon, { ICON_NAMES } from 'components/Icon';
import { aboutUsHash } from 'config/constants';
import { scrollTo } from 'helpers/scrollTo';

function NavbatItem(props) {
  const { title, url, children, index, onClick, withArrow, isActive, isAuth, hash } = props;

  const handleRedirect = () => {
    const { onHideModal } = props;
    onHideModal();
    history.push(ROUTES.signUp);
  }
  const handleModalOpen = () => {
    const { onShowModal, onHideModal } = props;

    onShowModal({
      name: 'career-center',
      onClose: onHideModal,
      isConfirmation: true,
      onConfirm: handleRedirect,
      params: {
        title: 'Career Center',
        html: '<p>To explore the WeCare4&reg; Career Center and to post positions, search for candidates, or look for' +
          ' positions in either an Institutional Care Facility (short- and long-term care facility), or in a' +
          ' person’s home, you must be registered. If you are already registered, just <a href="/sign-in">log in</a>.</p>',
        confirm: 'Register Here',
      }
    });
  }

  return (
    <li
      className={classNames("main-menu__item", {
        "main-menu__item-active": isActive,
        "main-menu__item-container": children,
      })}>
      {
        !withArrow ? (
          // <Link
          //   className="main-menu__link"
          //   to={hash ? `${url}#${hash}` : url}
          // >
          //   {title}
          // </Link>

          <HashLink
            className="main-menu__link"
            to={hash ? `${url}#${hash}` : url}
            scroll={element => scrollTo(element, -150, 'smooth')}
          // smooth
          >
            {title}
          </HashLink>
        ) : withArrow && url ? (
          <button type="button" className="main-menu__link" onClick={() => history.push(url)}>
            {title}
            <Icon
              name={ICON_NAMES.arrowDropdown}
              className="icon--arr-down main-menu__link-arrow" />
          </button>
        ) : (
          <button className="main-menu__link">
            {title}
            <Icon
              name={ICON_NAMES.arrowDropdown}
              className="icon--arr-down main-menu__link-arrow" />
          </button>
        )
      }
      {
        children &&
        <div className="main-menu__submenu">
          <ul className="main-menu__submenu-inner">
            {children}
          </ul>
        </div>
      }
    </li>
  );
}

function Navbar(props) {
  const { menuItems, isMobile, isAuth, onShowModal, onHideModal, hash: hashId } = props;

  return (
    <nav className="main-menu">
      <ul
        className={classNames("main-menu__list", {
          "main-menu__list--mobile": isMobile,
        })}>
        {
          menuItems.map((menuItem, index) => {
            return (
              <NavbatItem
                key={menuItem.title}
                title={menuItem.title}
                url={menuItem.url}
                index={index}
                isAuth={isAuth}
                isActive={menuItem.url === history.location.pathname}
                onShowModal={onShowModal}
                onHideModal={onHideModal}
                withArrow={menuItem.withArrow || false}>
                {
                  menuItem.submenu &&
                  menuItem.submenu.map((subItem, index) => {
                    const title = subItem.title;
                    const hash = aboutUsHash.find(hash => hash.label === title);

                    const isActive = hashId ? hashId.replace('#', '') === hash?.value : subItem.url === history.location.pathname;
                    // const isActive = !hashId ? subItem.url === history.location.pathname : hashId === hash?.value;

                    return (
                      <NavbatItem
                        key={title}
                        title={title}
                        url={subItem.url}
                        index={index}
                        withArrow={false}
                        isAuth={isAuth}
                        isActive={isActive}
                        hash={hash?.value}
                        onShowModal={onShowModal}
                        onHideModal={onHideModal}
                      />
                    )
                  })
                }
              </NavbatItem>
            );
          })
        }
      </ul>
    </nav>
  );
}

export default connect(
  null,
  {
    onShowModal: ModalModule.show,
    onHideModal: ModalModule.hide,
  }
)(Navbar);

// class NavbatItem extends Component {
//   handleRedirect = () => {
//     const { onHideModal } = this.props;
//     onHideModal();
//     history.push(ROUTES.signUp);
//   }
//   handleModalOpen = () => {
//     const { onShowModal, onHideModal } = this.props;

//     onShowModal({
//       name: 'career-center',
//       onClose: onHideModal,
//       isConfirmation: true,
//       onConfirm: this.handleRedirect,
//       params: {
//         title: 'Career Center',
//         html: '<p>To explore the WeCare4&reg; Career Center and to post positions, search for candidates, or look for' +
//           ' positions in either an Institutional Care Facility (short- and long-term care facility), or in a' +
//           ' person’s home, you must be registered. If you are already registered, just <a href="/sign-in">log in</a>.</p>',
//         confirm: 'Register Here',
//       }
//     });
//   }

//   handleHashChange = element => {
//     const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
//     const yOffset = -150;
//     window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
//   }

//   render() {
//     const { title, url, children, index, onClick, withArrow, isActive, isAuth, hash } = this.props;
//     console.log(this.props)
//     return (
//       <li
//         className={classNames("main-menu__item", {
//           "main-menu__item-active": isActive,
//           "main-menu__item-container": children,
//         })}>
//         {
//           !withArrow
//             ? <HashLink
//               className="main-menu__link"
//               to={hash ? `${url}#${hash}` : url}
//               smooth
//               scroll={this.handleHashChange}
//             >
//               {title}
//             </HashLink>
//             : <button
//               className="main-menu__link">
//               {title}
//               <Icon
//                 name={ICON_NAMES.arrowDropdown}
//                 className="icon--arr-down main-menu__link-arrow" />
//             </button>
//         }
//         {
//           children &&
//           <div className="main-menu__submenu">
//             <ul className="main-menu__submenu-inner">
//               {children}
//             </ul>
//           </div>
//         }
//       </li>
//     );
//   }
// }